import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import {
  extractInvoiceFromOrderHistory,
  extractTransportationFromOrderHistory,
  extractUnoFeeFromOrderHistory,
} from "@/features/my-order/features/order-history/utils";
import { toCamelKeyObject } from "@/utils/case";

const useOrderHistoryProformaInvoice = () => {
  const { data } = useOrderHistoryDetail();
  const proformaInvoices = data?.proforma_invoices;
  // 상품 대금 합계 — 바이어 유로 송금 프로포마는 유로라 원화 합계와 따로 더한다
  const paymentForGoodAmountByCurrency = { KRW: 0, EUR: 0 };
  proformaInvoices?.forEach((item) => {
    const {
      totalCollectedKrwAmount,
      actualTotalCollectedKrwAmount,
      isRemittedToBoutique,
      collectedCurrency,
    } = extractInvoiceFromOrderHistory(toCamelKeyObject(item));

    paymentForGoodAmountByCurrency[collectedCurrency] += isRemittedToBoutique
      ? actualTotalCollectedKrwAmount
      : totalCollectedKrwAmount;
  });
  const paymentForGoodAmount = paymentForGoodAmountByCurrency.KRW;
  const paymentForGoodEurAmount = paymentForGoodAmountByCurrency.EUR;

  const incidentalExpenses = data?.transportations.reduce((acc, item) => {
    const { fundRequestAmount } = extractTransportationFromOrderHistory(
      toCamelKeyObject(item)
    );

    return acc + fundRequestAmount;
  }, 0);

  const totalUnoFeeAmount = proformaInvoices?.reduce((acc, item) => {
    const { unoFeeAmount } = extractUnoFeeFromOrderHistory(
      toCamelKeyObject(item)
    );

    return acc + (unoFeeAmount ?? 0);
  }, 0);

  return {
    data,
    proformaInvoices,
    paymentForGoodAmount,
    paymentForGoodEurAmount,
    incidentalExpenses,
    totalUnoFeeAmount,
  };
};

export default useOrderHistoryProformaInvoice;
